var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('history-list-component',{attrs:{"history-type":'list',"historyKey":_vm.idx,"default-filter":_vm.defaultFilter}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }